import { erpAxios } from '..';

const getTroskoviDomacinstva = async (brojZahtjeva) => {
  const { data } = await erpAxios.get(`/troskovi-domacinstva/${brojZahtjeva}`);
  return data;
};

export default getTroskoviDomacinstva;
